import { fetchInitialDataRequest, fetchInitialDataResponse } from './mutations'
import { fetchRoles } from './modules/roles'
import { fetchUsers } from './modules/users'
import { fetchPermissions } from './modules/user'
import { fetchStatus } from './modules/status'
import { fetchSignTypes } from '@/store/modules/sign-types'

export const fetchInitialData = 'fetchInitialData'

const actions = {
  [fetchInitialData] ({ state, commit, dispatch }) {
    commit(fetchInitialDataRequest)
    return Promise.all([
      dispatch(fetchUsers),
      dispatch(fetchRoles),
      dispatch(fetchStatus),
      dispatch(fetchPermissions),
      dispatch(fetchSignTypes)
    ]).then(() => {
      commit(fetchInitialDataResponse)
    })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js